import { getSupportLogs, redactForSupport } from './redactedLogs';

export function createRedactedSupportBundle(extra?: Record<string, any>) {
  return redactForSupport({
    kind: 'intimsync-web-support-bundle',
    version: 1,
    createdAt: new Date().toISOString(),
    platform: 'web',
    location: {
      origin: window.location.origin,
      pathname: window.location.pathname,
      search: window.location.search ? '[PRESENT]' : '',
    },
    userAgent: navigator.userAgent,
    logs: getSupportLogs(),
    extra: extra || {},
  });
}

export async function copyRedactedSupportBundle(extra?: Record<string, any>) {
  const bundle = createRedactedSupportBundle(extra);
  const text = JSON.stringify(bundle, null, 2);

  if (!navigator.clipboard?.writeText) {
    throw new Error('Clipboard API is not available in this browser');
  }

  await navigator.clipboard.writeText(text);
  return bundle;
}
